const importAllSVG = (reqSvgs: __WebpackModuleApi.RequireContext, name: string) => {
  return reqSvgs.keys().reduce((images: object, path: string) => {
    const pathKey = `${path.replace('./', '').replace('.svg', '')}${name}`;
    return { ...images, [pathKey]: reqSvgs(path) };
  }, {});
};

const reqSvgsOutlined = require.context('./outlined', true, /\.svg$/);
const reqSvgsRounded = require.context('./rounded', true, /\.svg$/);
const reqSvgsSpecial = require.context('./special', true, /\.svg$/);
const reqSvgsFilled = require.context('./filled', true, /\.svg$/);

export const svgsOutlined = importAllSVG(reqSvgsOutlined, 'Outlined');
export const svgsRounded = importAllSVG(reqSvgsRounded, 'Rounded');
export const svgsSpecial = importAllSVG(reqSvgsSpecial, 'Special');
export const svgsFilled = importAllSVG(reqSvgsFilled, 'Filled');

export const Icons = {
  ...svgsOutlined,
  ...svgsRounded,
  ...svgsSpecial,
  ...svgsFilled,
} as const;

export type IconNames = keyof typeof Icons;
